import { Expand, Shrink } from 'lucide-react'
import { useEffect, useState } from 'react'

export function FullscreenButton() {
	const [isFullscreen, setIsFullscreen] = useState(false)

	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement)
		}

		document.addEventListener('fullscreenchange', handleFullscreenChange)
		return () => document.removeEventListener('fullscreenchange', handleFullscreenChange)
	}, [])

	const toggleFullscreen = () => {
		if (!document.fullscreenElement) {
			document.documentElement.requestFullscreen()
		} else {
			document.exitFullscreen()
		}
	}

	return (
		<button
			type="button"
			onClick={toggleFullscreen}
			className="fixed top-4 left-4 z-50 rounded bg-black/40 p-2 text-white transition-all hover:scale-105 hover:bg-black/70"
		>
			{isFullscreen ? <Shrink /> : <Expand />}
		</button>
	)
}
